module.exports = __webpack_public_path__ + "static/img/question4-7.f60c250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question4-7.png
// module id = FUrh
// module chunks = 1